export const DOCUMENT_TYPE_BANK_GUIDEBOOK = 'bank-guidebook';
